import { UserPlus, Grid } from 'react-feather';

const pagesSection = [
  {
    href: 'produkter',
    title: 'Produkter',
    icon: Grid,
    children: [
      {
        href: '/partner/sites',
        title: 'Landningssidor',
      },
      {
        href: '/partner/hemsidor',
        title: 'Hemsidor',
      },
    ],
  },
  {
    href: 'leads',
    title: 'Kundförfrågningar',
    icon: UserPlus,
  },
];

const navItems = [
  {
    title: '',
    pages: pagesSection,
  },
];

export default navItems;
